import React from "react";

const Text = ({ type = "div", typeClass = "", content = "" }) => {
  const TextType = `${type}`;
  return <TextType className={typeClass}>{content}</TextType>;
};

export default Text;
